import * as R from 'ramda';


export default function BulkArchiveReportInstancesDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  loaderService,
  ssDialogService,
  bulkArchiveReportInstancesConfirmDialog
) {
  const vm = this;
  
  vm.archiveIsSelected = false;
  vm.hasData = true;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleBulkArchive = _handleBulkArchive;
  vm.handleSelectAll = _handleSelectAll;

  /** ************************************************
   * Event Handlers
   */
  activate();

  function activate() {
    $scope.$on('selectBulkReportInstanceChange', () => {
      _handleSelectReportInstanceChange();
    });
  }

  function _handleBulkArchive($event) {
    const _ids = [];

    R.forEach((reportInstance) => {
      if (reportInstance.isBulkArchive) {
        _ids.push(reportInstance.reportInstanceId);
      }
    }, vm.reportInstances);

    ssDialogService.dialogs.reports.bulkArchiveReportInstancesConfirmDialog = ssDialogService.alert(
      bulkArchiveReportInstancesConfirmDialog.getOptions($event, {
        reportTypeId: vm.reportType.uniqueId,
        reportInstanceIds: _ids,
        updateCallBack: _broadcastEvents,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.reports.bulkArchiveReportInstancesConfirmDialog);
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.reports.bulkArchiveReportInstancesDialog);
  }

  function _handleSelectAll() {
    R.forEach((reportInstance) => {
      reportInstance.isBulkArchive = vm.selectAll;
      vm.archiveIsSelected = vm.selectAll;
    }, vm.reportInstances);
  }

  function _handleSelectReportInstanceChange() {
    const selectedIds = [];
    R.forEach((item) => {
      if (item.isBulkArchive === true) {
        selectedIds.push(item.reportInstanceId);
      }
    }, vm.reportInstances);
    vm.archiveIsSelected = selectedIds.length > 0;
    vm.selectAll = selectedIds.length === vm.reportInstances.length;
  }

  /** ************************************************
   * Private Functions
   */
  function _broadcastEvents() {
    $rootScope.$broadcast('refreshReportInstances', { reportType: vm.reportType });
  }
}

BulkArchiveReportInstancesDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'loaderService',
  'ssDialogService',
  'bulkArchiveReportInstancesConfirmDialog',
];
